var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, observable, makeObservable } from 'mobx';
import { AspectEventReception } from './AspectEventReception';
import { memoize } from '../../../../utils/mobx/decorators/memoize';
import { AspectEventObserve } from './AspectEventObserve';
import { AspectEventCreation } from './AspectEventCreation';
import { AspectEventLatest } from './AspectEventLatest';
import { AspectEventTypes } from './AspectEventTypes';
export class AspectEvents {
    parent;
    programmaticListeners = observable.array(); // manually coded listeners
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get aspect() {
        return this.parent;
    }
    get eventCreation() {
        return new AspectEventCreation(this);
    }
    get eventReception() {
        return new AspectEventReception(this);
    }
    get eventLatest() {
        return new AspectEventLatest(this);
    }
    get eventTypes() {
        return new AspectEventTypes(this);
    }
    get observedEvents() {
        return new AspectEventObserve(this);
    }
    get latestEventOfType() {
        return this.eventLatest.latestEventProxy;
    }
    get eventsOfType() {
        return this.eventTypes.eventsOfType;
    }
    addListener(handlerKey, f) {
        this.programmaticListeners.push([handlerKey, f]);
    }
    removeListener(f) {
        this.programmaticListeners.replace(this.programmaticListeners.filter(f1 => f1[1] !== f));
    }
}
__decorate([
    observable.shallow
], AspectEvents.prototype, "programmaticListeners", void 0);
__decorate([
    memoize
], AspectEvents.prototype, "eventCreation", null);
__decorate([
    memoize
], AspectEvents.prototype, "eventReception", null);
__decorate([
    memoize
], AspectEvents.prototype, "eventLatest", null);
__decorate([
    memoize
], AspectEvents.prototype, "eventTypes", null);
__decorate([
    memoize
], AspectEvents.prototype, "observedEvents", null);
__decorate([
    action
], AspectEvents.prototype, "addListener", null);
__decorate([
    action
], AspectEvents.prototype, "removeListener", null);
